import { Box, Skeleton } from '@mui/material';
export const KanbanBoardSkeleton = () => {
    return (
        <Box sx={{ backgroundColor: '#f5f5f5', p: 2, borderRadius: 1, height: 'calc(100vh - 190px)', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', gap: 2, overflowX: 'auto', height: '100%', pb: 2, pt: 1 }}>
                {/* Show 4-5 stage columns */}
                {[1, 2, 3, 4, 5].map((columnIndex) => (
                    <Box
                        key={columnIndex}
                        sx={{
                            minWidth: 320,
                            maxWidth: 320,
                            backgroundColor: '#fff',
                            borderRadius: 2,
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            border: '1px solid #e0e0e0'
                        }}
                    >
                        {/* Stage Header Skeleton */}
                        <Box sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Skeleton variant="text" width={150} height={28} />
                                <Skeleton variant="circular" width={24} height={24} />
                            </Box>
                            <Skeleton variant="text" width={100} height={20} />
                        </Box>

                        {/* Action Buttons Skeleton */}
                        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                            {[1, 2, 3, 4, 5].map((btn) => (
                                <Skeleton key={btn} variant="circular" width={32} height={32} />
                            ))}
                        </Box>

                        {/* Document Cards Skeleton - 2-3 cards per column */}
                        <Box sx={{ flex: 1, overflowY: 'auto' }}>
                            {[1, 2, 3].map((cardIndex) => (
                                <Box
                                    key={cardIndex}
                                    sx={{
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: 1,
                                        p: 1.5,
                                        mb: 1.5,
                                        border: '1px solid #e0e0e0'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                        <Skeleton variant="rectangular" width={36} height={36} sx={{ borderRadius: 1 }} />
                                        <Box sx={{ flex: 1 }}>
                                            <Skeleton variant="text" width="80%" height={20} sx={{ mb: 0.5 }} />
                                            <Skeleton variant="text" width="60%" height={16} />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                                        <Skeleton variant="rectangular" width={60} height={20} sx={{ borderRadius: 0.5 }} />
                                        <Skeleton variant="rectangular" width={60} height={20} sx={{ borderRadius: 0.5 }} />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

// Document List Skeleton Loader Component - For Data View
export const DocumentListSkeleton = () => {
    return (
        <Box sx={{ backgroundColor: '#fff', minHeight: 600, p: 3 }}>
            {/* Header Skeleton */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Skeleton variant="text" width={200} height={40} />
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Skeleton variant="rectangular" width={220} height={40} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width={220} height={40} sx={{ borderRadius: 1 }} />
                </Box>
            </Box>

            {/* Stage Sections Skeleton - Show 3 stages */}
            {[1, 2, 3].map((stageIndex) => (
                <Box key={stageIndex} sx={{ mb: 4 }}>
                    {/* Stage Header */}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Skeleton variant="text" width={180} height={32} />
                            <Skeleton variant="text" width={80} height={24} />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            {[1, 2, 3, 4, 5].map((btn) => (
                                <Skeleton key={btn} variant="circular" width={36} height={36} />
                            ))}
                        </Box>
                    </Box>

                    {/* Document Cards Skeleton - Show 2 cards per stage */}
                    {[1, 2].map((cardIndex) => (
                        <Box key={cardIndex} sx={{ mb: 2 }}>
                            {/* Date skeleton */}
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Skeleton variant="circular" width={14} height={14} sx={{ mr: 1 }} />
                                <Skeleton variant="text" width={150} height={20} />
                            </Box>

                            {/* Card skeleton */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    p: 2,
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: 1,
                                }}
                            >
                                <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1, mr: 2 }} />
                                <Box sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width="60%" height={24} sx={{ mb: 0.5 }} />
                                    <Skeleton variant="text" width="40%" height={20} />
                                </Box>
                                <Skeleton variant="circular" width={32} height={32} />
                            </Box>
                        </Box>
                    ))}
                </Box>
            ))}
        </Box>
    );
};

export const TasksViewSkeleton = () => {
    return (
        <Box sx={{ backgroundColor: '#fff', minHeight: 600, p: 3 }}>
            {/* Header Skeleton */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Skeleton variant="text" width={150} height={40} />
                <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 1 }} />
            </Box>

            {/* Stage Sections with Tasks - Show 3 stages */}
            {[1, 2, 3].map((stageIndex) => (
                <Box key={stageIndex} sx={{ mb: 4 }}>
                    {/* Stage Header */}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                        <Skeleton variant="text" width={200} height={32} />
                        <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1 }} />
                    </Box>

                    {/* Task Cards Skeleton - Show 2-3 tasks per stage */}
                    {[1, 2, 3].map((taskIndex) => (
                        <Box
                            key={taskIndex}
                            sx={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: 1,
                                p: 2,
                                mb: 2,
                                border: '1px solid #e0e0e0'
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
                                    <Skeleton variant="text" width="90%" height={20} />
                                </Box>
                                <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 0.5 }} />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                                <Skeleton variant="circular" width={32} height={32} />
                                <Skeleton variant="text" width={120} height={32} />
                            </Box>
                        </Box>
                    ))}
                </Box>
            ))}
        </Box>
    );
};
